import { Folder, FileText, Images } from "lucide-react";
import { sampleFileUrl } from "@/lib/samples";

export const FolderCard = ({ folder, checked, onCheck, onOpen, testId }) => {
  const url = folder.cover_id ? sampleFileUrl(folder.cover_id) : "";
  return (
    <div
      data-testid={testId}
      className={`group relative overflow-hidden rounded-lg border bg-card transition-all hover:-translate-y-0.5 hover:shadow-md ${checked ? "border-2 border-[#1B66C9]" : "border-border"}`}
    >
      <button onClick={onOpen} className="block w-full text-left" data-testid={`${testId}-open`}>
        <div className="relative aspect-[4/3] overflow-hidden bg-muted">
          {folder.cover_type === "image" && <img src={url} alt={folder.name} loading="lazy" className="h-full w-full object-cover" />}
          {folder.cover_type === "video" && <video src={`${url}#t=0.5`} muted preload="metadata" playsInline className="h-full w-full object-cover" />}
          {folder.cover_type === "pdf" && (
            <div className="flex h-full w-full items-center justify-center bg-secondary text-muted-foreground">
              <FileText size={40} />
            </div>
          )}
          {!folder.cover_type && (
            <div className="flex h-full w-full items-center justify-center bg-secondary text-muted-foreground">
              <Folder size={40} />
            </div>
          )}
          <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-black/60 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-white backdrop-blur" data-testid={`${testId}-count`}>
            <Images size={11} /> {folder.count} item{folder.count === 1 ? "" : "s"}
          </span>
        </div>
        <div className="p-3">
          <p className="truncate font-display text-sm font-bold" data-testid={`${testId}-name`}>{folder.name}</p>
        </div>
      </button>
      <label className="absolute right-3 top-3 flex h-7 w-7 cursor-pointer items-center justify-center rounded-full bg-white/90 shadow" onClick={(e) => e.stopPropagation()}>
        <input type="checkbox" data-testid={`${testId}-check`} checked={checked} onChange={onCheck} className="h-4 w-4 accent-[#1B66C9]" aria-label={`Select ${folder.name}`} />
      </label>
    </div>
  );
};
